import { useQuery } from '@tanstack/react-query';
import { pensionSchemeService } from '../../../services/pension-scheme.service';

const deriveSchemeKey = (payload) => {
  if (!payload) return null;
  return (
    payload.memberNumber ||
    payload.MemberNumber ||
    payload.member_number ||
    payload.memberId ||
    payload.MemberId ||
    payload.member_id ||
    payload.scheme_id ||
    payload.schemeId ||
    null
  );
};

export function useSchemeBeneficiaries(schemeSelectionPayload) {
  const schemeKey = deriveSchemeKey(schemeSelectionPayload) || 'none';
  const payloadSignature = schemeSelectionPayload ? JSON.stringify(schemeSelectionPayload) : 'no-payload';

  return useQuery({
    queryKey: ['scheme-beneficiaries', schemeKey, payloadSignature],
    enabled: Boolean(schemeSelectionPayload && schemeKey !== 'none'),
    queryFn: async () => {
      const { requestId, ...selectPayload } = schemeSelectionPayload || {};
      const selectionResult = await pensionSchemeService.selectScheme(selectPayload);
      console.log('Select scheme response:', selectionResult);
      return pensionSchemeService.getBeneficiaries();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}